import { createSvgIcon } from "@mui/material";

export const NameIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11" fill="none">
        <path d="M4.26173e-06 10.1855L3.55552 0H5.87642L9.50686 10.1855H7.50477L5.69652 4.89559C5.52006 4.348 5.33549 3.72944 5.14281 3.03993C4.95013 2.35042 4.73748 1.56451 4.50488 0.682223H4.88878C4.66237 1.57035 4.45629 2.36208 4.27054 3.05743C4.08478 3.75278 3.90969 4.3655 3.74527 4.89559L1.99607 10.1855H4.26173e-06ZM2.07101 7.66171V6.19227H7.43585V7.66171H2.07101Z" fill="currentColor"/>
    </svg>,
    'NameIcon'
)
